<template>
  <section id="hero">
    <v-img
      max-height="92vh"
      :src="require('@/assets/pool.jpg')"
      class="white--text"
      gradient="to right, rgba(5, 11, 31, .6), rgba(5, 11, 31, .6)"
    >
      <v-container class="fill-height">
        <v-responsive
          class="d-flex align-center"
        >
          <h1 style="font-weight:bold; font-size: 35px; color:white;" >CRYSTALLINE H<sub>2</sub>0</h1>
          <base-body>
            <p style="font-weight:bold; font-size: 19px; color:white;">Eau verte, Eau trouble, pH qui fluctue, odeur de chlore, peau irritée, yeux qui piquent, cheveux secs ?</p>
            <p style="font-size: 19px; color:white;">Pour une eau plus claire, douce, agréable, non irritante, sans odeur, sécuritaire. Pour un entretien économique, facile et court.</p>
            <ul style="font-size: 19px; color:white;" >
              <li>Permet de diminuer la quantité de désinfectant à utiliser et maximise ses effets,</li>
              <li>Empêche les algues de se développer</li>
              <li>Remplace le pH +, pH - et les floculents</li>
              <li>Agglomère les particules en suspension trop petites pour être retenues par le filtre</li>
              <li>Augmente la durée de vie de vos équipements</li>
              <li>Est facile à utiliser et à entreposer</li>
              <li>Avec un peu de chlore, remplace tous les autres produits</li>
            </ul>
          </base-body>

          <div
            :class="$vuetify.breakpoint.smAndDown ? 'flex-column align-start' : 'align-center'"
            class="d-flex flex-wrap"
          >
            <a href="#"
               @click="$vuetify.goTo('#theme-features', options)"
            >
              <span>Découvrir notre produit</span>
              <div class="wave"></div>
            </a>
          </div>
        </v-responsive>
      </v-container>
    </v-img>
  </section>
</template>

<style>
  @import url('https://fonts.googleapis.com/css?family=Poppins:300,400,500,600,700,800,900&display=swap');
  *
  {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  a{
    position: relative;
    display: block;
    padding: 10px 30px;
    border: 2px solid #00aeff;
    text-transform: uppercase;
    font-size: 18px;
    letter-spacing: 4px;
    color: #00aeff;
    text-decoration: none;
    overflow: hidden;
    background-color: white;
  }
  a span
  {
    position: relative;
    color: black;
    z-index: 1;
    transition: 1s;
  }
  a:hover span{
    color: #fff;
  }
  a .wave
  {
    position: absolute;
    left: 0;
    width: 100%;
    height: 100%;
    background: #00aeff;
    transition: 1s;
  }
  a:hover .wave
  {
    top: 0;
  }
  a .wave:before
  {
    content: '';
    position: absolute;
    top: -22px;
    left: 0;
    width: 100%;
    height: 22px;
    background: url(../../assets/file.png);
    animation: animate 0.5s linear infinite;
  }
  @keyframes animate
  {
    0%
    {
      background-position-x: 0;
    }
    100%
    {
      background-position-x: 118px;
    }
  }
</style>
<script>
  export default {
    name: 'SectionHero',

    provide: {
      theme: { isDark: true },
    },

    computed: {
      minHeight () {
        const height = this.$vuetify.breakpoint.mdAndUp ? '100vh' : '50vh'
        return `calc(${height} - ${this.$vuetify.application.top}px)`
      },
      options(){
        return {
          duration: 300,
          offset: 0,
          easing: 'easeInOutCubic',
        }
      },
    },
  }
</script>
